module.exports = __webpack_public_path__ + "img/panneau-publicitaire-ok.442bae3f.jpg";